<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="用户姓名" prop="name">
                <a-input v-model="field.name" placeholder="请填写用户姓名" />
            </a-form-model-item>
            <a-form-model-item label="用户信息" v-if="!item.id">
                <a-input v-if="idMode === 'idno'" v-model="field.idno" placeholder="请填写用户身份证号" :style="{ width: '70%' }" />
                <a-button v-if="idMode === 'idno'" type="link" @click="() => ((idMode = 'no'), (field.idno = ''), (field.gender = 'M'), (field.bir = ''))">
                    无身份证？
                </a-button>
                <a-date-picker v-if="idMode === 'no'" v-model="field.bir" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="请选择出生日期" :style="{ width: '35%' }" />
                <a-radio-group v-if="idMode === 'no'" button-style="solid" v-model="field.gender" :style="{ width: '35%', marginLeft: '10px' }">
                    <a-radio-button value="M">
                        男
                    </a-radio-button>
                    <a-radio-button value="F">
                        女
                    </a-radio-button>
                </a-radio-group>
                <a-button v-if="idMode === 'no'" type="link" @click="() => ((idMode = 'idno'), (field.idno = ''), (field.gender = 'M'), (field.bir = ''))">
                    填写身份证
                </a-button>
            </a-form-model-item>
            <a-form-model-item label="用户信息" v-else>{{ item.idno || '未填写身份证号' }} \ {{ item.bir }} \ {{ item.gender === 'M' ? '男' : '女' }}</a-form-model-item>
            <a-form-model-item label="联系电话" prop="mob">
                <a-input v-model="field.mob" placeholder="请填写联系手机号码" />
            </a-form-model-item>
            <a-form-model-item label="训练师" prop="cta">
                <a-input v-model="field.cta" placeholder="请填写训练师" />
            </a-form-model-item>
            <a-form-model-item label="用户分组" prop="org">
                <a-select v-if="empMode === 'sel'" show-search v-model="field.org" :filter-option="false" :not-found-content="null" @search="doLoadOrg" :style="{ width: '70%' }">
                    <a-select-option v-for="item in orgs" :key="item.id" :value="item.id" :label="item.name">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
                <a-button v-if="empMode === 'sel'" type="link" @click="() => ((empMode = 'add'), (field.org = ''))">
                    列表不存在？
                </a-button>
                <a-input v-if="empMode === 'add'" v-model="field.org" placeholder="请填写用户分组名称" :style="{ width: '70%' }" />
                <a-button v-if="empMode === 'add'" type="link" @click="() => ((empMode = 'sel'), (field.org = ''))">
                    选择已有
                </a-button>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            idMode: 'idno',
            empMode: 'sel',
            orgs: [],
            field: {
                id: '',
                name: '',
                cta: '',
                idno: '',
                gender: 'M',
                bir: '',
                mob: '',
                org: ''
            },
            rules: {
                name: [{ required: true, message: '请填写用户名称', trigger: 'blur' }],
                cta: [{ required: true, message: '请填写训练师名称', trigger: 'blur' }],
                mob: [{ required: true, message: '请填写手机号码', trigger: 'blur' }],
                org: [{ required: true, message: '请填写用户分组', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            this.field.org = this.item.org.id
        }
        this.doLoadOrg()
    },
    methods: {
        doLoadOrg(name) {
            this.$http
                .get('/cts/ate/tester/org/query', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.orgs = result.datas
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/tester/info/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
                this.field.org = this.item.org.id
            }
        }
    }
}
</script>
